module.exports = __webpack_public_path__ + "static/contact-f946f495d379e330b5fb9715b6a8a90a.jpg";